export class ForgeProjectInvitation {
    constructor(model) {
        this.email = model.email;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = new Date(model.updatedAt);
        this.role = model.role;
        this.effectiveRole = model.effectiveRole;
        this.workspaceInvitationId = model.workspaceInvitationId;
        this.forgeProjectId = model.forgeProjectId;
        this.createdById = model.createdById;
    }
    toRemote() {
        return {
            ...this,
            createdAt: this.createdAt.toISOString(),
            updatedAt: this.updatedAt.toISOString(),
        };
    }
}
